module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "bottom",
      "width": "400",
      "trigger": "click"
    },
    model: {
      value: (_vm.popoverVisible),
      callback: function($$v) {
        _vm.popoverVisible = $$v
      },
      expression: "popoverVisible"
    }
  }, [_c('AgencyTreeCore', _vm._g(_vm._b({
    ref: "treeCore",
    on: {
      "selectTreeAgency": _vm.selectAgency,
      "checkAgencyLeavesCore": _vm.checkAgencyLeaves,
      "checkAgenciesCore": _vm.checkAgencies
    }
  }, 'AgencyTreeCore', _vm.$attrs, false), _vm.$listeners))], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-070d476a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AgencyTree/AgencyTree.vue
// module id = 839
// module chunks = 11